var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1051_16845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 3.99998V1.99998C4.66667 1.82317 4.7369 1.6536 4.86193 1.52858C4.98695 1.40355 5.15652 1.33331 5.33333 1.33331H13.3333C13.5101 1.33331 13.6797 1.40355 13.8047 1.52858C13.9298 1.6536 14 1.82317 14 1.99998V11.3333C14 11.5101 13.9298 11.6797 13.8047 11.8047C13.6797 11.9297 13.5101 12 13.3333 12H11.3333V14C11.3333 14.368 11.0333 14.6666 10.662 14.6666H2.67133C2.58342 14.6672 2.49626 14.6503 2.41488 14.6171C2.3335 14.5838 2.25949 14.5348 2.19711 14.4728C2.13472 14.4109 2.0852 14.3372 2.05137 14.2561C2.01754 14.1749 2.00009 14.0879 2 14L2.002 4.66665C2.002 4.29865 2.302 3.99998 2.67333 3.99998H4.66667ZM6 3.99998H11.3333V10.6666H12.6667V2.66665H6V3.99998Z",
    fill: "#03053D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1051_16845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1c8d99da3287169395e11d29f64bf388.svg";
export { ForwardRef as ReactComponent };